import { CanvasStatus } from "../types";
import { IGame } from "../types/game";
import GameState from "./game-state";

export default class GetNextState extends GameState {

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(game: IGame){
        super(game);
    }

    enter(): void {
        // No need to check bonus here - StampBlockState handles it
    }

    update(frameTime: number): void {        
        super.update(frameTime);

        // Keep shifting until we have a block (like original while loop)
        // Reference: quadra/source/player.cc:255-256
        let shiftCount = 0;
        while (!this.canvas.bloc) {
            this.canvas.shiftNext();
            shiftCount++;
            if (shiftCount > 10) {
                console.error(`[GetNextState] Infinite loop: shifted ${shiftCount} times but still no bloc! next=${this.canvas.next}, next2=${this.canvas.next2}, next3=${this.canvas.next3}`);
                break;
            }
        }
        

        // Mark player as ready to play again (matches original canvas->idle = 1)
        this.canvas.idle = 1;
        this.canvas.status = CanvasStatus.PLAYING;
        
        // Note: Original calls canvas->set_next() here (line 258) to update UI zones,
        // but we don't have that UI system, so we skip it.
        // The original also sets canvas->frame_start = overmind.framecount (line 259),
        // but we don't track frame_start in our implementation.
        
        // Remove this state (like original ret())
        // This returns to NormalState, which will then push ProcessKeyState or DeadState
        this.markDone(); // Mark as done (matches original ret())
    }

    toString(): string {
        return "Get Next"
    }
}